import React, { type ReactNode } from "react";
import { cn } from "src/utilities/shadcnUtils";

// the maximum width content on the page can stretch to
export const PAGE_WIDTH = 1120;

/**
 * A wrapper component that adds max width and padding to the page. Optionally adds a heading and subheading. Applicable to most dashboard pages.
 */
const DashboardPage = ({
  children,
  heading,
  subHeading,
  maxWidth,
  outerContainerClassName,
  className,
  center,
}: {
  children: ReactNode;
  heading?: ReactNode;
  subHeading?: ReactNode;
  maxWidth?: number | string;
  outerContainerClassName?: string;
  className?: string;
  /** Horizontally center the page content (used by the borrower dashboard). */
  center?: boolean;
}) => {
  return (
    <div
      className={cn("p-6 flex h-full", center ? "justify-center" : "justify-start", outerContainerClassName)}
    >
      <div
        className={cn("w-full flex flex-col h-full", className)}
        style={{ maxWidth: maxWidth || PAGE_WIDTH }}
      >
        <div>
          {heading ? <h1 className="font-serif-deck text-4xl">{heading}</h1> : null}
          {subHeading ? <h2 className="text-base font-light mt-1 max-w-2xl">{subHeading}</h2> : null}
        </div>
        {children}
        <div className="w-full p-1" />
      </div>
    </div>
  );
};

export default React.memo(DashboardPage);
